import { singleItemDefaultConfig } from '../singleitemdisplay/SingleItemDisplay'
import * as H from 'history'
import { getColumns } from './columns'

export const getDefaultControlledConfig =  (history: H.History) => ({
    ...singleItemDefaultConfig,
    header: 'Business',
    columns: getColumns(history)
})